var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-toolbar',{staticClass:"md-layout"},[_c('md-icon',{staticClass:"md-layout-item md-size-20"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('h4',{staticClass:"md-layout-item md-size-80"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/TitleToolbar.vue